import styles from "../styles.module.scss";

declare global {
    interface Window {
        scs_father_day_2026?: boolean;
    }
}

export default function SuperOffer(props) {
    return window.scs_black_friday_2025 ? <>
        {window.scs_new_design_2026 ? '' :
            <h4 className={`${styles.bf_heading}`}>{`${window.scs_black_friday_2025_h1}`}</h4>}
        <h6 className={`${styles.bf_choose_heading}`}><span>Choose Your Setup</span></h6>
    </> : '';
}
